export default function OwnerNotifyEmail() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Notify via Email
            </div>
            <div className="page-sub" id="page-sub">
              Notifications › Email Broadcast
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div className="stat-grid mb16">
            <div className="stat-card">
              <div className="stat-icon">📤</div>
              <div className="stat-label">Tenants</div>
              <div className="stat-value">3</div>
              <div className="stat-delta delta-neu">Total registered</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">✅</div>
              <div className="stat-label">Active</div>
              <div className="stat-value">3</div>
              <div className="stat-delta delta-up">Currently residing</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">⏳</div>
              <div className="stat-label">KYC Pending</div>
              <div className="stat-value">1</div>
              <div className="stat-delta delta-dn">Awaiting verification</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">💸</div>
              <div className="stat-label">Bill Due</div>
              <div className="stat-value">1</div>
              <div className="stat-delta delta-dn">Tenants with due bills</div>
            </div>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 340px",
              gap: 16,
              alignItems: "start",
            }}
          >
            <div className="card">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginBottom: 16,
                  paddingBottom: 12,
                  borderBottom: "0.5px solid var(--border-light)",
                }}
              >
                <span style={{ fontSize: 18 }}>📧</span>
                <div style={{ fontSize: 14, fontWeight: 700 }}>
                  Send Email Notification
                </div>
              </div>
              <div className="form-group mb12">
                <label>Send via API</label>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <select id="po-api-sel-email" style={{ flex: 1 }}>
                    <option value={1}>SMTP — noreply@nestmanager.in</option>
                  </select>
                  <span
                    style={{
                      fontSize: 10,
                      padding: "3px 8px",
                      borderRadius: 99,
                      background: "#EAF3DE",
                      color: "#27500A",
                      whiteSpace: "nowrap",
                      fontWeight: 600,
                    }}
                  >
                    ✓ Active
                  </span>
                </div>
                <div className="input-hint" style={{ marginTop: 3 }}>
                  Only active APIs shown.{" "}
                  <span
                    onclick="showPage('po-api-email',document.querySelector('[data-id=po-api-email]'))"
                    style={{
                      color: "var(--blue)",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                  >
                    Manage Email APIs →
                  </span>
                </div>
              </div>
              <hr
                style={{
                  border: "none",
                  borderTop: "0.5px solid var(--border-light)",
                  marginBottom: 12,
                }}
              />
              <div className="form-group mb12">
                <label>Recipients</label>
                <select
                  id="po-recp-sel-email"
                  onchange="poToggleCustomInput('email',this.value)"
                >
                  <option value="all">All Tenants (3)</option>
                  <option value="active">Active Tenants (3)</option>
                  <option value="kyc_pending">KYC Pending (1)</option>
                  <option value="kyc_not_applied">KYC Not Applied (1)</option>
                  <option value="due_bill">Bill Due Tenants (1)</option>
                  <option value="custom">Custom Selection</option>
                </select>
              </div>
              <div
                id="po-custom-box-email"
                style={{ display: "none", marginBottom: 12 }}
              >
                <label
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    color: "var(--text-secondary)",
                    display: "block",
                    marginBottom: 5,
                  }}
                >
                  Email Addresses (one per line)
                </label>
                <textarea
                  id="po-custom-input-email"
                  rows={4}
                  placeholder="priya@gmail.com
            karan@example.com"
                  oninput="poCountRecipients('email')"
                  style={{ width: "100%", fontSize: 12, resize: "vertical" }}
                  defaultValue={""}
                />
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    marginTop: 3,
                  }}
                >
                  Recipients: <strong id="po-count-email">0</strong>
                </div>
              </div>
              <div className="form-group mb12">
                <label>Subject *</label>
                <input
                  type="text"
                  id="po-msg-subj-email"
                  placeholder="e.g. Your Bill for April 2025 is Ready"
                />
              </div>
              <div className="form-group mb12">
                <label>Message *</label>
                <textarea
                  id="po-msg-body-email"
                  rows={5}
                  placeholder="Type your message or use a template from the right…"
                  style={{ width: "100%", resize: "vertical" }}
                  defaultValue={""}
                />
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-tertiary)",
                    marginTop: 4,
                  }}
                >
                  Use {"{"}name{"}"}, {"{"}room{"}"}, {"{"}amount{"}"}, {"{"}
                  due_date
                  {"}"}, {"{"}month{"}"} as placeholders
                </div>
              </div>
              <div className="form-group mb12">
                <label>Schedule</label>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      fontSize: 12,
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="radio"
                      name="po-sched-email"
                      defaultValue="now"
                      defaultChecked=""
                      onchange="toggleSchedTime('po-email',this.value)"
                    />{" "}
                    Send Now
                  </label>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      fontSize: 12,
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="radio"
                      name="po-sched-email"
                      defaultValue="later"
                      onchange="toggleSchedTime('po-email',this.value)"
                    />{" "}
                    Schedule Later
                  </label>
                </div>
                <div
                  id="sched-fields-po-email"
                  style={{ display: "none", marginTop: 8 }}
                >
                  <input
                    type="datetime-local"
                    style={{
                      fontSize: 12,
                      padding: "6px 10px",
                      border: "0.5px solid var(--border-mid)",
                      borderRadius: 7,
                      width: "100%",
                    }}
                  />
                </div>
              </div>
              <button
                onclick="poSendNotification('Email','email')"
                style={{
                  background: "#185FA5",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 24px",
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: "pointer",
                  width: "100%",
                }}
              >
                📧 Send Email Notification
              </button>
            </div>
            <div className="card">
              <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>
                Message Templates
              </div>
              <div
                className="tpl-card"
                style={{
                  background: "var(--bg-primary)",
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: 12,
                  cursor: "pointer",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 8,
                    marginBottom: 6,
                  }}
                >
                  <div>
                    <div
                      style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}
                    >
                      Rent Due Reminder
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        rent
                      </span>
                    </div>
                  </div>
                  <button
                    onclick="poUseTemplate('email',1)"
                    style={{
                      padding: "4px 12px",
                      background: "#185FA5",
                      color: "#fff",
                      border: "none",
                      borderRadius: 5,
                      fontSize: 11,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Use ↗
                  </button>
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "var(--text-tertiary)",
                    marginBottom: 5,
                  }}
                >
                  <strong>Subject:</strong> Rent Due — Action Required
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    lineHeight: "1.6",
                    maxHeight: 60,
                    overflow: "hidden",
                  }}
                >
                  Dear{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}name{"}"}
                  </span>
                  ,<br />
                  <br />
                  This is a reminder that your rent of ₹
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}amount{"}"}
                  </span>{" "}
                  is due on{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}date{"}"}
                  </span>
                  .<br />
                  <br />
                  Please make the payment at your earliest convenience to avoid
                  late fees.
                  <br />
                  <br />
                  Pay online:{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}link{"}"}
                  </span>
                  <br />
                  <br />
                  Regards,
                  <br />
                  NestManager Team
                </div>
              </div>
              <div
                className="tpl-card"
                style={{
                  background: "var(--bg-primary)",
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: 12,
                  cursor: "pointer",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 8,
                    marginBottom: 6,
                  }}
                >
                  <div>
                    <div
                      style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}
                    >
                      Payment Confirmation
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        payment
                      </span>
                    </div>
                  </div>
                  <button
                    onclick="poUseTemplate('email',2)"
                    style={{
                      padding: "4px 12px",
                      background: "#185FA5",
                      color: "#fff",
                      border: "none",
                      borderRadius: 5,
                      fontSize: 11,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Use ↗
                  </button>
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "var(--text-tertiary)",
                    marginBottom: 5,
                  }}
                >
                  <strong>Subject:</strong> Payment Received — ₹{"{"}amount{"}"}
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    lineHeight: "1.6",
                    maxHeight: 60,
                    overflow: "hidden",
                  }}
                >
                  Dear{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}name{"}"}
                  </span>
                  ,<br />
                  <br />
                  We have successfully received your payment of ₹
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}amount{"}"}
                  </span>{" "}
                  for{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}month{"}"}
                  </span>
                  .<br />
                  <br />
                  Thank you for your prompt payment.
                  <br />
                  <br />
                  Download receipt:{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}link{"}"}
                  </span>
                  <br />
                  <br />
                  Regards,
                  <br />
                  NestManager Team
                </div>
              </div>
              <div
                className="tpl-card"
                style={{
                  background: "var(--bg-primary)",
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: 12,
                  cursor: "pointer",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 8,
                    marginBottom: 6,
                  }}
                >
                  <div>
                    <div
                      style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}
                    >
                      Subscription Renewal
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        subscription
                      </span>
                    </div>
                  </div>
                  <button
                    onclick="poUseTemplate('email',3)"
                    style={{
                      padding: "4px 12px",
                      background: "#185FA5",
                      color: "#fff",
                      border: "none",
                      borderRadius: 5,
                      fontSize: 11,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Use ↗
                  </button>
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "var(--text-tertiary)",
                    marginBottom: 5,
                  }}
                >
                  <strong>Subject:</strong> Your {"{"}plan{"}"} Plan Expires on{" "}
                  {"{"}
                  date{"}"}
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    lineHeight: "1.6",
                    maxHeight: 60,
                    overflow: "hidden",
                  }}
                >
                  Dear{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}name{"}"}
                  </span>
                  ,<br />
                  <br />
                  Your{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}plan{"}"}
                  </span>{" "}
                  subscription is expiring on{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}date{"}"}
                  </span>
                  .<br />
                  <br />
                  To continue using NestManager without interruption, please
                  renew your plan.
                  <br />
                  <br />
                  Renew now:{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}link{"}"}
                  </span>
                  <br />
                  <br />
                  Regards,
                  <br />
                  NestManager Team
                </div>
              </div>
              <div
                className="tpl-card"
                style={{
                  background: "var(--bg-primary)",
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: 12,
                  cursor: "pointer",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 8,
                    marginBottom: 6,
                  }}
                >
                  <div>
                    <div
                      style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}
                    >
                      Welcome Email
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        welcome
                      </span>{" "}
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        onboarding
                      </span>
                    </div>
                  </div>
                  <button
                    onclick="poUseTemplate('email',4)"
                    style={{
                      padding: "4px 12px",
                      background: "#185FA5",
                      color: "#fff",
                      border: "none",
                      borderRadius: 5,
                      fontSize: 11,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Use ↗
                  </button>
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "var(--text-tertiary)",
                    marginBottom: 5,
                  }}
                >
                  <strong>Subject:</strong> Welcome to NestManager 🏠
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    lineHeight: "1.6",
                    maxHeight: 60,
                    overflow: "hidden",
                  }}
                >
                  Dear{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}name{"}"}
                  </span>
                  ,<br />
                  <br />
                  Welcome to NestManager! Your account has been created
                  successfully.
                  <br />
                  <br />
                  Login here:{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}link{"}"}
                  </span>
                  <br />
                  <br />
                  If you have any questions, reply to this email.
                  <br />
                  <br />
                  Regards,
                  <br />
                  NestManager Team
                </div>
              </div>
              <div
                className="tpl-card"
                style={{
                  background: "var(--bg-primary)",
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: 12,
                  cursor: "pointer",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 8,
                    marginBottom: 6,
                  }}
                >
                  <div>
                    <div
                      style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}
                    >
                      KYC Pending
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        kyc
                      </span>
                    </div>
                  </div>
                  <button
                    onclick="poUseTemplate('email',5)"
                    style={{
                      padding: "4px 12px",
                      background: "#185FA5",
                      color: "#fff",
                      border: "none",
                      borderRadius: 5,
                      fontSize: 11,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Use ↗
                  </button>
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "var(--text-tertiary)",
                    marginBottom: 5,
                  }}
                >
                  <strong>Subject:</strong> Action Required — KYC Verification
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    lineHeight: "1.6",
                    maxHeight: 60,
                    overflow: "hidden",
                  }}
                >
                  Dear{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}name{"}"}
                  </span>
                  ,<br />
                  <br />
                  Your KYC verification is still pending. Please upload your
                  documents to complete verification.
                  <br />
                  <br />
                  Upload documents:{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}link{"}"}
                  </span>
                  <br />
                  <br />
                  Regards,
                  <br />
                  NestManager Team
                </div>
              </div>
              <div
                className="tpl-card"
                style={{
                  background: "var(--bg-primary)",
                  border: "0.5px solid var(--border-light)",
                  borderRadius: "var(--radius-md)",
                  padding: 12,
                  cursor: "pointer",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 8,
                    marginBottom: 6,
                  }}
                >
                  <div>
                    <div
                      style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}
                    >
                      Late Fee Notice
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      <span
                        style={{
                          background: "var(--bg-secondary)",
                          border: "0.5px solid var(--border-light)",
                          borderRadius: 99,
                          padding: "1px 7px",
                          fontSize: 10,
                          color: "var(--text-tertiary)",
                        }}
                      >
                        late fee
                      </span>
                    </div>
                  </div>
                  <button
                    onclick="poUseTemplate('email',6)"
                    style={{
                      padding: "4px 12px",
                      background: "#185FA5",
                      color: "#fff",
                      border: "none",
                      borderRadius: 5,
                      fontSize: 11,
                      fontWeight: 600,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Use ↗
                  </button>
                </div>
                <div
                  style={{
                    fontSize: 10,
                    color: "var(--text-tertiary)",
                    marginBottom: 5,
                  }}
                >
                  <strong>Subject:</strong> Late Fee Applied — ₹{"{"}fee{"}"}
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--text-secondary)",
                    lineHeight: "1.6",
                    maxHeight: 60,
                    overflow: "hidden",
                  }}
                >
                  Dear{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}name{"}"}
                  </span>
                  ,<br />
                  <br />A late fee of ₹
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}fee{"}"}
                  </span>{" "}
                  has been applied to your account as the rent was not paid by
                  the due date.
                  <br />
                  <br />
                  Total outstanding: ₹
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}amount{"}"}
                  </span>
                  <br />
                  <br />
                  Pay now:{" "}
                  <span
                    style={{
                      background: "#FEF3C7",
                      color: "#92400E",
                      borderRadius: 3,
                      padding: "0 3px",
                      fontWeight: 600,
                    }}
                  >
                    {"{"}link{"}"}
                  </span>
                  <br />
                  <br />
                  Regards,
                  <br />
                  NestManager Team
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
